module.exports = __webpack_public_path__ + "img/simpInstallments.9a5a8d41.png";